import { isNullish } from "replo-utils/lib/misc";

import useChatMessagesUsage from "./useChatMessagesUsage";

const useChatMessageLimits = ():
  | {
      hasUnlimitedMessages: true;
      hasReachedLimit: false;
      messagesRemaining: null;
    }
  | {
      hasUnlimitedMessages: false;
      hasReachedLimit: boolean;
      messagesRemaining: number;
    } => {
  const chatMessageUsage = useChatMessagesUsage();

  if (isNullish(chatMessageUsage?.maximum)) {
    return {
      hasUnlimitedMessages: true,
      hasReachedLimit: false,
      messagesRemaining: null,
    };
  } else {
    const messagesRemaining =
      chatMessageUsage.maximum - chatMessageUsage.current;

    return {
      hasUnlimitedMessages: false,
      hasReachedLimit: messagesRemaining <= 0,
      messagesRemaining,
    };
  }
};

export default useChatMessageLimits;
